$(document).on('appReady', () => {
  const AUTOPLAY_THRESHOLD = 15000
  const $videos = $('.video.is__noPlayButton.is__autoplay:not(.is__played)')

  if ($videos.length) {
    const displayVideoPlayButton = () => $videos.removeClass('is__noPlayButton')
    setTimeout(displayVideoPlayButton, AUTOPLAY_THRESHOLD)
  }
})
